<template>
  <div class="q_pad_lr15px q_mar_t15px">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
      <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          error-text="请求失败，点击重新加载"
      >
        <div class="q_mar_b20px q_bor_bottom q_pad_b20px" v-for="item in list" :key="item.activityId"
             @click="goToActivdea(item.activityId)">
          <div class="q_color_gray q_text_s">{{ '参与时长 ' + item.signDuration +' 分钟'}}</div>
          <div class="q_text_m q_bold q_mar_t15px">{{ item.activityName }}</div>
        </div>
      </van-list>

    </van-pull-refresh>
    <!--空数据-->
    <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
      <img src="@/assets/image/none.png" style="width: 26vw;"/>
      <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
    </div>
  </div>
</template>

<script>
import {listUserFlowActivity} from "@/api/activity";

export default {
  name: 'Service',
  props: {
    msg: String
  },
  data() {
    return {
      showEmpty: false,
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      pageParam: {
        pageNum: 0,
        pageSize: 10,
      },
    }
  },
  methods: {
    /**
     * 下拉刷新
     */
    onRefresh() {
      this.pageParam = {
        pageNum: 0,
        pageSize: 5,
      }
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    /**
     * 下滑加载更多
     */
    onLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //查询服务记录信息列表
      listUserFlowActivity(this.pageParam).then(res => {
        if (res.total == 0) {
          this.showEmpty = true
        }
        //是否下拉刷新
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        for (let i = 0; i < res.rows.length; i++) {
          this.list.push(res.rows[i]);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= res.total) {
          this.finished = true;
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    goToActivdea(id) {
      this.$router.push({
        path: '/activity/Activdea', query: {id: id}
      });
    },
  }
}
</script>
